"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateWave = exports.updateSurveySettings = exports.updateSurvey = exports.updateQuestSettings = exports.updateQuest = exports.updateQueryWithoutSave = exports.updateQuery = exports.unscheduleMessage = exports.unarchiveSurvey = exports.unarchiveQuest = exports.toggleCollapsedDesignAssignment = exports.toggleCollapsedDeployAssignment = exports.toggleArchivedSurveys = exports.toggleArchivedAssignments = exports.setWaveOpenStatusAndSave = exports.setWaveOpenStatus = exports.setVizData = exports.setVisibleDeploymentIds = exports.setSelectedDeploymentIds = exports.setQueryList = exports.setProjectList = exports.setProjectFlows = exports.setOrganizationList = exports.setExpandedAllDesignAssignments = exports.setExpandedAllDeployAssignments = exports.setDevTags = exports.setCurrentSurveyListHandle = exports.setCurrentSurveyId = exports.setCurrentSurveyHandles = exports.setCurrentSurveyHandle = exports.setCurrentQuerySettings = exports.setCurrentQueryId = exports.setCurrentProjectId = exports.setCurrentDeploymentIds = exports.setCurrentDeploymentId = exports.setCurrentAssignmentIdOnly = exports.setCurrentAssignmentId = exports.resetState = exports.removeWave = exports.reloadCurrentProject = exports.moveSurveyAndSave = exports.moveSurvey = exports.loadProjectList = exports.loadProject = exports.loadDevTags = exports.initialState = exports.deleteSurvey = exports.deleteQuest = exports.deleteMessage = exports.deleteCurrentQueryWithoutSave = exports.deleteCurrentQuery = exports["default"] = exports.createWave = exports.createSurvey = exports.createQuest = exports.createFlow = exports.clearVisibleDeploymentIds = exports.changeDesignFilter = exports.changeDeployFilter = exports.archiveSurvey = exports.archiveQuest = exports.addNewQueryWithoutSave = exports.addNewQuery = void 0;
var _react = _interopRequireDefault(require("react"));
var _reduxActions = require("redux-actions");
var _cccisdApollo = require("cccisd-apollo");
var _projectListQuery = _interopRequireDefault(require("../queries/projectListQuery.graphql"));
var _designTabQuery = _interopRequireDefault(require("../queries/designTabQuery.graphql"));
var _projectSettings = _interopRequireDefault(require("./projectSettings.graphql"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _difference2 = _interopRequireDefault(require("lodash/difference"));
var _union2 = _interopRequireDefault(require("lodash/union"));
var _xor2 = _interopRequireDefault(require("lodash/xor"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _uniqBy2 = _interopRequireDefault(require("lodash/uniqBy"));
var _uniq2 = _interopRequireDefault(require("lodash/uniq"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _admin = require("../selectors/admin.js");
var _nanoid = require("nanoid");
var _getColumnTree = require("../pages/Data/CustomQueryForm/getColumnTree.js");
var _handleActions;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var Boilerplate = window.cccisd.boilerplate;
var Fortress = window.cccisd.fortress;
var defaultQuerySettings = {
  assignmentId: 0,
  deploymentIds: 'all',
  surveyHandles: 'all',
  columns: {
    'pawn.pawnId': {
      id: 'pawn.pawnId',
      sort: 1,
      label: 'System ID',
      type: 'number'
    },
    'pawn.createdDate': {
      id: 'pawn.createdDate',
      sort: 2,
      label: 'Created Date',
      type: 'string'
    }
  },
  codedValues: true,
  missingValues: true,
  waveHandle: false,
  waveTimepoint: false,
  metrics: {
    types: ['qualitative', 'quantitative', 'additional_coding', 'formula'],
    list: []
  },
  filter: null,
  visualizationSettings: {}
};
var initialState = {
  organizationList: [],
  projectList: [],
  currentProjectId: 0,
  currentAssignmentId: 0,
  currentDeploymentId: 0,
  selectedDeploymentIds: [],
  currentDeploymentIds: [],
  deploymentDropdownVisible: false,
  currentSurveyId: 0,
  currentSurveyHandle: '0',
  currentSurveyHandles: [],
  surveyDropdownVisible: false,
  expandedDesignAssignmentIds: [],
  expandedDeployAssignmentIds: [],
  showArchivedAssignments: false,
  showArchivedSurveys: [],
  currentSurveyListHandles: {},
  designFilter: '',
  deployFilter: '',
  devTags: [],
  queryList: [],
  currentQueryId: '0',
  currentQuerySettings: defaultQuerySettings,
  deploymentListLimit: 10000,
  vizData: {},
  visibleDeploymentIds: null
};

// Actions
exports.initialState = initialState;
var SET_ORGANIZATION_LIST = 'assignment/admin/SET_ORGANIZATION_LIST';
var SET_PROJECT_LIST = 'assignment/admin/SET_PROJECT_LIST';
var SET_PROJECT_FLOWS = 'assignment/admin/SET_PROJECT_FLOWS';
var SET_CURRENT_PROJECT_ID = 'assignment/admin/SET_CURRENT_PROJECT_ID';
var SET_CURRENT_ASSIGNMENT_ID = 'assignment/admin/SET_CURRENT_ASSIGNMENT_ID';
var SET_CURRENT_ASSIGNMENT_ID_ONLY = 'assignment/admin/SET_CURRENT_ASSIGNMENT_ID_ONLY';
var SET_CURRENT_DEPLOYMENT_ID = 'assignment/admin/SET_CURRENT_DEPLOYMENT_ID';
var SET_SELECTED_DEPLOYMENT_IDS = 'assignment/admin/SET_SELECTED_DEPLOYMENT_IDS';
var SET_CURRENT_DEPLOYMENT_IDS = 'assignment/admin/SET_CURRENT_DEPLOYMENT_IDS';
var SET_CURRENT_SURVEY_ID = 'assignment/admin/SET_CURRENT_SURVEY_ID';
var SET_CURRENT_SURVEY_HANDLE = 'assignment/admin/SET_CURRENT_SURVEY_HANDLE';
var SET_CURRENT_SURVEY_HANDLES = 'assignment/admin/SET_CURRENT_SURVEY_HANDLES';
var SET_EXPANDED_ALL_DESIGN_ASSIGNMENTS = 'assignment/admin/SET_EXPANDED_ALL_DESIGN_ASSIGNMENTS';
var TOGGLE_COLLAPSED_DESIGN_ASSIGNMENT = 'assignment/admin/TOGGLE_COLLAPSED_DESIGN_ASSIGNMENT';
var SET_EXPANDED_ALL_DEPLOY_ASSIGNMENTS = 'assignment/admin/SET_EXPANDED_ALL_DEPLOY_ASSIGNMENTS';
var TOGGLE_COLLAPSED_DEPLOY_ASSIGNMENT = 'assignment/admin/TOGGLE_COLLAPSED_DEPLOY_ASSIGNMENT';
var TOGGLE_ARCHIVED_ASSIGNMENTS = 'assignment/admin/TOGGLE_ARCHIVED_ASSIGNMENTS';
var TOGGLE_ARCHIVED_SURVEYS = 'assignment/admin/TOGGLE_ARCHIVED_SURVEYS';
var MOVE_SURVEY = 'assignment/admin/MOVE_SURVEY';
var SET_CURRENT_SURVEY_LIST_HANDLE = 'assignment/admin/SET_CURRENT_SURVEY_LIST_HANDLE';
var SET_WAVE_OPEN_STATUS = 'assignment/admin/SET_WAVE_OPEN_STATUS';
var CHANGE_DESIGN_FILTER = 'assignment/admin/CHANGE_DESIGN_FILTER';
var CHANGE_DEPLOY_FILTER = 'assignment/admin/CHANGE_DEPLOY_FILTER';
var SET_DEV_TAGS = 'assignment/admin/SET_DEV_TAGS';
var SET_QUERY_LIST = 'assignment/admin/SET_QUERY_LIST';
var ADD_NEW_QUERY = 'assignment/admin/ADD_NEW_QUERY';
var UPDATE_QUERY = 'assignment/admin/UPDATE_QUERY';
var DELETE_CURRENT_QUERY = 'assignment/admin/DELETE_CURRENT_QUERY';
var SET_CURRENT_QUERY_ID = 'assignment/admin/SET_CURRENT_QUERY_ID';
var SET_CURRENT_QUERY_SETTINGS = 'assignment/admin/SET_CURRENT_QUERY_SETTINGS';
var SET_VIZ_DATA = 'assignment/admin/SET_VIZ_DATA';
var SET_VISIBLE_DEPLOYMENT_IDS = 'assignment/admin/SET_VISIBLE_DEPLOYMENT_IDS';
var CLEAR_VISIBLE_DEPLOYMENT_IDS = 'assignment/admin/CLEAR_VISIBLE_DEPLOYMENT_IDS';
var RESET_STATE = 'assignment/admin/RESET_STATE';

// Action Creators
var setOrganizationList = (0, _reduxActions.createAction)(SET_ORGANIZATION_LIST);
exports.setOrganizationList = setOrganizationList;
var setProjectList = (0, _reduxActions.createAction)(SET_PROJECT_LIST);
exports.setProjectList = setProjectList;
var setCurrentProjectId = (0, _reduxActions.createAction)(SET_CURRENT_PROJECT_ID);
exports.setCurrentProjectId = setCurrentProjectId;
var setCurrentAssignmentId = (0, _reduxActions.createAction)(SET_CURRENT_ASSIGNMENT_ID);
exports.setCurrentAssignmentId = setCurrentAssignmentId;
var setCurrentAssignmentIdOnly = (0, _reduxActions.createAction)(SET_CURRENT_ASSIGNMENT_ID_ONLY);
exports.setCurrentAssignmentIdOnly = setCurrentAssignmentIdOnly;
var setCurrentDeploymentId = (0, _reduxActions.createAction)(SET_CURRENT_DEPLOYMENT_ID);
exports.setCurrentDeploymentId = setCurrentDeploymentId;
var setSelectedDeploymentIds = (0, _reduxActions.createAction)(SET_SELECTED_DEPLOYMENT_IDS);
exports.setSelectedDeploymentIds = setSelectedDeploymentIds;
var setCurrentDeploymentIds = (0, _reduxActions.createAction)(SET_CURRENT_DEPLOYMENT_IDS);
exports.setCurrentDeploymentIds = setCurrentDeploymentIds;
var setCurrentSurveyId = (0, _reduxActions.createAction)(SET_CURRENT_SURVEY_ID);
exports.setCurrentSurveyId = setCurrentSurveyId;
var setCurrentSurveyHandle = (0, _reduxActions.createAction)(SET_CURRENT_SURVEY_HANDLE);
exports.setCurrentSurveyHandle = setCurrentSurveyHandle;
var setCurrentSurveyHandles = (0, _reduxActions.createAction)(SET_CURRENT_SURVEY_HANDLES);
exports.setCurrentSurveyHandles = setCurrentSurveyHandles;
var setProjectFlows = (0, _reduxActions.createAction)(SET_PROJECT_FLOWS);
exports.setProjectFlows = setProjectFlows;
var setExpandedAllDesignAssignments = (0, _reduxActions.createAction)(SET_EXPANDED_ALL_DESIGN_ASSIGNMENTS);
exports.setExpandedAllDesignAssignments = setExpandedAllDesignAssignments;
var toggleCollapsedDesignAssignment = (0, _reduxActions.createAction)(TOGGLE_COLLAPSED_DESIGN_ASSIGNMENT);
exports.toggleCollapsedDesignAssignment = toggleCollapsedDesignAssignment;
var setExpandedAllDeployAssignments = (0, _reduxActions.createAction)(SET_EXPANDED_ALL_DEPLOY_ASSIGNMENTS);
exports.setExpandedAllDeployAssignments = setExpandedAllDeployAssignments;
var toggleCollapsedDeployAssignment = (0, _reduxActions.createAction)(TOGGLE_COLLAPSED_DEPLOY_ASSIGNMENT);
exports.toggleCollapsedDeployAssignment = toggleCollapsedDeployAssignment;
var toggleArchivedAssignments = (0, _reduxActions.createAction)(TOGGLE_ARCHIVED_ASSIGNMENTS);
exports.toggleArchivedAssignments = toggleArchivedAssignments;
var toggleArchivedSurveys = (0, _reduxActions.createAction)(TOGGLE_ARCHIVED_SURVEYS);
exports.toggleArchivedSurveys = toggleArchivedSurveys;
var moveSurvey = (0, _reduxActions.createAction)(MOVE_SURVEY);
exports.moveSurvey = moveSurvey;
var setCurrentSurveyListHandle = (0, _reduxActions.createAction)(SET_CURRENT_SURVEY_LIST_HANDLE);
exports.setCurrentSurveyListHandle = setCurrentSurveyListHandle;
var setWaveOpenStatus = (0, _reduxActions.createAction)(SET_WAVE_OPEN_STATUS);
exports.setWaveOpenStatus = setWaveOpenStatus;
var changeDesignFilter = (0, _reduxActions.createAction)(CHANGE_DESIGN_FILTER);
exports.changeDesignFilter = changeDesignFilter;
var changeDeployFilter = (0, _reduxActions.createAction)(CHANGE_DEPLOY_FILTER);
exports.changeDeployFilter = changeDeployFilter;
var setDevTags = (0, _reduxActions.createAction)(SET_DEV_TAGS);
exports.setDevTags = setDevTags;
var setQueryList = (0, _reduxActions.createAction)(SET_QUERY_LIST);
exports.setQueryList = setQueryList;
var addNewQueryWithoutSave = (0, _reduxActions.createAction)(ADD_NEW_QUERY);
exports.addNewQueryWithoutSave = addNewQueryWithoutSave;
var updateQueryWithoutSave = (0, _reduxActions.createAction)(UPDATE_QUERY);
exports.updateQueryWithoutSave = updateQueryWithoutSave;
var deleteCurrentQueryWithoutSave = (0, _reduxActions.createAction)(DELETE_CURRENT_QUERY);
exports.deleteCurrentQueryWithoutSave = deleteCurrentQueryWithoutSave;
var setCurrentQueryId = (0, _reduxActions.createAction)(SET_CURRENT_QUERY_ID);
exports.setCurrentQueryId = setCurrentQueryId;
var setCurrentQuerySettings = (0, _reduxActions.createAction)(SET_CURRENT_QUERY_SETTINGS);
exports.setCurrentQuerySettings = setCurrentQuerySettings;
var setVizData = (0, _reduxActions.createAction)(SET_VIZ_DATA);
exports.setVizData = setVizData;
var setVisibleDeploymentIds = (0, _reduxActions.createAction)(SET_VISIBLE_DEPLOYMENT_IDS);
exports.setVisibleDeploymentIds = setVisibleDeploymentIds;
var clearVisibleDeploymentIds = (0, _reduxActions.createAction)(CLEAR_VISIBLE_DEPLOYMENT_IDS);
exports.clearVisibleDeploymentIds = clearVisibleDeploymentIds;
var resetState = (0, _reduxActions.createAction)(RESET_STATE);
exports.resetState = resetState;
var saveQueries = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(state) {
    var _result$data$groups$q;
    var deletedIds,
      currentProjectId,
      currentQueries,
      result,
      existingQueries,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            deletedIds = _args.length > 1 && _args[1] !== undefined ? _args[1] : [];
            currentProjectId = state.currentProjectId;
            currentQueries = (0, _admin.getCurrentProjectQueries)(state);
            _context.next = 5;
            return _cccisdApollo.client.query({
              query: _projectSettings["default"],
              variables: {
                groupId: currentProjectId
              },
              fetchPolicy: 'network-only'
            });
          case 5:
            result = _context.sent;
            existingQueries = ((_result$data$groups$q = result.data.groups.questproject.group.settings) === null || _result$data$groups$q === void 0 ? void 0 : _result$data$groups$q.queryList) || [];
            _context.next = 9;
            return _cccisdAxios["default"].put(Boilerplate.route('api.nexus.group.update', {
              group: currentProjectId
            }), {
              settings: {
                queryList: (0, _uniqBy2["default"])([].concat(_toConsumableArray(currentQueries), _toConsumableArray(existingQueries)).filter(function (item) {
                  return !deletedIds.includes(item.id);
                }), 'id')
              }
            });
          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function saveQueries(_x) {
    return _ref.apply(this, arguments);
  };
}();
var addNewQuery = function addNewQuery() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dispatch, getState) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch(addNewQueryWithoutSave.apply(void 0, args));
              _context2.next = 3;
              return saveQueries(getState().assignment.admin);
            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};
exports.addNewQuery = addNewQuery;
var updateQuery = function updateQuery() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(dispatch, getState) {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              dispatch(updateQueryWithoutSave.apply(void 0, args));
              _context3.next = 3;
              return saveQueries(getState().assignment.admin);
            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
};
exports.updateQuery = updateQuery;
var deleteCurrentQuery = function deleteCurrentQuery() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(dispatch, getState) {
      var deletedQueryId;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              deletedQueryId = getState().assignment.admin.currentQueryId;
              dispatch(deleteCurrentQueryWithoutSave.apply(void 0, args));
              _context4.next = 4;
              return saveQueries(getState().assignment.admin, [deletedQueryId]);
            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return function (_x6, _x7) {
      return _ref4.apply(this, arguments);
    };
  }();
};
exports.deleteCurrentQuery = deleteCurrentQuery;
var loadProjectList = function loadProjectList() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    forceReload = _ref5.forceReload;
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(dispatch, getState) {
      var state, result, organizationHash, organizationList, projectList;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              // Don't load projects twice
              state = getState().assignment.admin;
              if (!(state.projectList.length > 0 && !forceReload)) {
                _context5.next = 3;
                break;
              }
              return _context5.abrupt("return");
            case 3:
              if (!(Fortress.user.acting.data_type === 'guest')) {
                _context5.next = 6;
                break;
              }
              window.location = Boilerplate.url('account/login');
              return _context5.abrupt("return");
            case 6:
              result = null;
              _context5.prev = 7;
              _context5.next = 10;
              return _cccisdApollo.client.query({
                query: _projectListQuery["default"],
                fetchPolicy: 'network-only'
              });
            case 10:
              result = _context5.sent;
              _context5.next = 16;
              break;
            case 13:
              _context5.prev = 13;
              _context5.t0 = _context5["catch"](7);
              return _context5.abrupt("return");
            case 16:
              organizationHash = result.data.groups.questprojectList.reduce(function (obj, project) {
                var group = project.parentGroup.questorganization.group;
                if (!obj[group.groupId]) {
                  obj[group.groupId] = _objectSpread(_objectSpread({}, (0, _pick2["default"])(group, ['groupId', 'label'])), {}, {
                    restrictionsLevel: project.parentGroup.questorganization.fields.level
                  });
                }
                return obj;
              }, {});
              organizationList = Object.values(organizationHash).sort(function (a, b) {
                return a.label.localeCompare(b.label);
              });
              projectList = result.data.groups.questprojectList.map(function (project) {
                return _objectSpread(_objectSpread({}, project.group), {}, {
                  fields: project.fields,
                  organizationId: project.parentGroup.questorganization.group.groupId
                });
              });
              dispatch(setProjectList(projectList));
              dispatch(setOrganizationList(organizationList));
            case 21:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[7, 13]]);
    }));
    return function (_x8, _x9) {
      return _ref6.apply(this, arguments);
    };
  }();
};
exports.loadProjectList = loadProjectList;
var loadProject = function loadProject(groupId) {
  var deploymentIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(dispatch, getState) {
      var deploymentListLimit, result, isLimited, limitedAssignents;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (!(Fortress.user.acting.data_type === 'guest')) {
                _context6.next = 3;
                break;
              }
              window.location = Boilerplate.url('account/login');
              return _context6.abrupt("return");
            case 3:
              deploymentListLimit = getState().assignment.admin.deploymentListLimit;
              result = null;
              _context6.prev = 5;
              _context6.next = 8;
              return _cccisdApollo.client.query({
                query: _designTabQuery["default"],
                variables: {
                  groupId: groupId,
                  deploymentIds: deploymentIds,
                  limit: deploymentListLimit
                },
                fetchPolicy: 'network-only'
              });
            case 8:
              result = _context6.sent;
              _context6.next = 14;
              break;
            case 11:
              _context6.prev = 11;
              _context6.t0 = _context6["catch"](5);
              return _context6.abrupt("return");
            case 14:
              isLimited = result.data.flows.assignmentList.some(function (assignment) {
                return assignment.deploymentList.length >= deploymentListLimit;
              });
              if (isLimited) {
                limitedAssignents = result.data.flows.assignmentList.filter(function (assignment) {
                  return assignment.deploymentList.length >= deploymentListLimit;
                });
                (0, _cccisdNotification["default"])({
                  type: 'warning',
                  message: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("b", null, "Warning!")), "The following Quests have many data collection waves. Some data collection waves may not be shown.", /*#__PURE__*/_react["default"].createElement("ul", null, limitedAssignents.map(function (assignment) {
                    return /*#__PURE__*/_react["default"].createElement("li", {
                      key: assignment.assignmentId
                    }, assignment.label);
                  }))),
                  duration: 8000
                });
              }
              dispatch(setProjectFlows({
                groupId: groupId,
                flows: result.data.flows
              }));
              dispatch(setCurrentProjectId(groupId));
            case 18:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[5, 11]]);
    }));
    return function (_x10, _x11) {
      return _ref7.apply(this, arguments);
    };
  }();
};
exports.loadProject = loadProject;
var loadDevTags = function loadDevTags() {
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(dispatch, getState) {
      var response;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _cccisdAxios["default"].get(Boilerplate.route('poly.api.v1.tag.tagNames') + '?scope=developer');
            case 2:
              response = _context7.sent;
              dispatch(setDevTags(response.data));
            case 4:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));
    return function (_x12, _x13) {
      return _ref8.apply(this, arguments);
    };
  }();
};
exports.loadDevTags = loadDevTags;
var reloadCurrentProject = function reloadCurrentProject() {
  return /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(dispatch, getState) {
      var _getState$assignment$, currentProjectId, projectList, newCurrentProjectId, questTabPermissions, projectWithPermission;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _getState$assignment$ = getState().assignment.admin, currentProjectId = _getState$assignment$.currentProjectId, projectList = _getState$assignment$.projectList;
              newCurrentProjectId = currentProjectId;
              if (!projectList.find(function (p) {
                return Number.parseInt(p.groupId, 10) === Number.parseInt(currentProjectId, 10);
              })) {
                questTabPermissions = ['quest.design', 'quest.deploy', 'quest.status', 'quest.code', 'quest.view_data', 'quest.permissions', 'quest.admin'];
                projectWithPermission = projectList.find(function (p) {
                  return Fortress.hasAnyAccess(questTabPermissions, p.groupId);
                });
                newCurrentProjectId = !projectWithPermission ? 0 : Number.parseInt(projectWithPermission.groupId, 10);
              }
              _context8.next = 5;
              return dispatch(loadProject(newCurrentProjectId));
            case 5:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));
    return function (_x14, _x15) {
      return _ref9.apply(this, arguments);
    };
  }();
};
exports.reloadCurrentProject = reloadCurrentProject;
var createQuest = function createQuest(values) {
  return /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(dispatch, getState) {
      var currentProjectId, response, isSuccess;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              currentProjectId = getState().assignment.admin.currentProjectId;
              _context9.next = 3;
              return _cccisdAxios["default"].post(Boilerplate.route('api.assignment.store'), {
                group: currentProjectId,
                label: values.title,
                description: values.subtitle,
                product: values.productId || null,
                settings: (0, _omit2["default"])(values, ['title', 'subtitle', 'productId'])
              });
            case 3:
              response = _context9.sent;
              if (!response.data.errors) {
                _context9.next = 6;
                break;
              }
              throw response.data.errors;
            case 6:
              isSuccess = response.data.status === 'success';
              if (!isSuccess) {
                _context9.next = 10;
                break;
              }
              _context9.next = 10;
              return dispatch(reloadCurrentProject());
            case 10:
              return _context9.abrupt("return", isSuccess);
            case 11:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));
    return function (_x16, _x17) {
      return _ref10.apply(this, arguments);
    };
  }();
};
exports.createQuest = createQuest;
var updateQuest = function updateQuest(assignmentId, values) {
  return /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(dispatch, getState) {
      var updateData, response, isSuccess;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              updateData = {
                assignmentId: assignmentId,
                label: values.title,
                description: values.subtitle,
                product: values.productId || null,
                settings: (0, _omit2["default"])(values, ['title', 'subtitle', 'handle', 'productId'])
              };
              if (values.handle) {
                updateData.handle = values.handle;
              }
              _context10.next = 4;
              return _cccisdAxios["default"].post(Boilerplate.route('api.assignment.update'), updateData);
            case 4:
              response = _context10.sent;
              isSuccess = response.data.status === 'success';
              if (!isSuccess) {
                _context10.next = 9;
                break;
              }
              _context10.next = 9;
              return dispatch(reloadCurrentProject());
            case 9:
              return _context10.abrupt("return", isSuccess);
            case 10:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));
    return function (_x18, _x19) {
      return _ref11.apply(this, arguments);
    };
  }();
};
exports.updateQuest = updateQuest;
var updateQuestSettings = function updateQuestSettings(assignmentId, settings) {
  return /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(dispatch, getState) {
      var response, isSuccess;
      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return _cccisdAxios["default"].post(Boilerplate.route("api.assignment.update"), {
                assignmentId: assignmentId,
                settings: settings
              });
            case 2:
              response = _context11.sent;
              if (!response.data.errors) {
                _context11.next = 5;
                break;
              }
              throw response.data.errors;
            case 5:
              isSuccess = response.data.status === 'success';
              if (!isSuccess) {
                _context11.next = 9;
                break;
              }
              _context11.next = 9;
              return dispatch(reloadCurrentProject());
            case 9:
              return _context11.abrupt("return", isSuccess);
            case 10:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));
    return function (_x20, _x21) {
      return _ref12.apply(this, arguments);
    };
  }();
};
exports.updateQuestSettings = updateQuestSettings;
var archiveQuest = function archiveQuest(assignmentId) {
  return /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(dispatch, getState) {
      var response, isSuccess;
      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return _cccisdAxios["default"].put(Boilerplate.route('api.assignment.archive', {
                assignmentId: assignmentId
              }));
            case 2:
              response = _context12.sent;
              if (response.data.errors && response.data.errors.assignment) {
                (0, _cccisdNotification["default"])({
                  type: 'danger',
                  message: response.data.errors.assignment[0]
                });
              }
              isSuccess = response.data.status === 'success';
              if (!isSuccess) {
                _context12.next = 8;
                break;
              }
              _context12.next = 8;
              return dispatch(reloadCurrentProject());
            case 8:
              return _context12.abrupt("return", isSuccess);
            case 9:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));
    return function (_x22, _x23) {
      return _ref13.apply(this, arguments);
    };
  }();
};
exports.archiveQuest = archiveQuest;
var unarchiveQuest = function unarchiveQuest(assignmentId) {
  return /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(dispatch, getState) {
      var response, isSuccess;
      return _regeneratorRuntime().wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return _cccisdAxios["default"].put(Boilerplate.route('api.assignment.unarchive', {
                assignmentId: assignmentId
              }));
            case 2:
              response = _context13.sent;
              if (response.data.errors && response.data.errors.assignment) {
                (0, _cccisdNotification["default"])({
                  type: 'danger',
                  message: response.data.errors.assignment[0]
                });
              }
              isSuccess = response.data.status === 'success';
              if (!isSuccess) {
                _context13.next = 8;
                break;
              }
              _context13.next = 8;
              return dispatch(reloadCurrentProject());
            case 8:
              return _context13.abrupt("return", isSuccess);
            case 9:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));
    return function (_x24, _x25) {
      return _ref14.apply(this, arguments);
    };
  }();
};
exports.unarchiveQuest = unarchiveQuest;
var deleteQuest = function deleteQuest(assignmentId) {
  return /*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(dispatch, getState) {
      var response, isSuccess;
      return _regeneratorRuntime().wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return _cccisdAxios["default"].put(Boilerplate.route("api.assignment.destroy", {
                assignmentId: assignmentId
              }));
            case 2:
              response = _context14.sent;
              if (response.data.errors && response.data.errors.assignment) {
                (0, _cccisdNotification["default"])({
                  type: 'danger',
                  message: response.data.errors.assignment[0]
                });
              }
              isSuccess = response.data.status === 'success';
              if (!isSuccess) {
                _context14.next = 8;
                break;
              }
              _context14.next = 8;
              return dispatch(reloadCurrentProject());
            case 8:
              return _context14.abrupt("return", isSuccess);
            case 9:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }));
    return function (_x26, _x27) {
      return _ref15.apply(this, arguments);
    };
  }();
};
exports.deleteQuest = deleteQuest;
var createSurvey = function createSurvey(surveyListId, values) {
  return /*#__PURE__*/function () {
    var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(dispatch, getState) {
      var response, isSuccess;
      return _regeneratorRuntime().wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return _cccisdAxios["default"].post(Boilerplate.route('api.assignmentSurvey.store'), {
                label: values.title,
                description: values.subtitle,
                assignmentSurveylistId: surveyListId,
                settings: (0, _omit2["default"])(values, ['title', 'subtitle'])
              });
            case 2:
              response = _context15.sent;
              if (!response.data.errors) {
                _context15.next = 5;
                break;
              }
              throw response.data.errors;
            case 5:
              isSuccess = response.data.status === 'success';
              if (!isSuccess) {
                _context15.next = 9;
                break;
              }
              _context15.next = 9;
              return dispatch(reloadCurrentProject());
            case 9:
              return _context15.abrupt("return", isSuccess);
            case 10:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }));
    return function (_x28, _x29) {
      return _ref16.apply(this, arguments);
    };
  }();
};
exports.createSurvey = createSurvey;
var updateSurvey = function updateSurvey(surveyId, values) {
  return /*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(dispatch, getState) {
      var response, isSuccess;
      return _regeneratorRuntime().wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return _cccisdAxios["default"].put(Boilerplate.route('api.assignmentSurvey.update', {
                surveyId: surveyId
              }), {
                label: values.title,
                description: values.subtitle,
                settings: (0, _omit2["default"])(values, ['title', 'subtitle'])
              });
            case 2:
              response = _context16.sent;
              if (!response.data.errors) {
                _context16.next = 5;
                break;
              }
              throw response.data.errors;
            case 5:
              isSuccess = response.data.status === 'success';
              if (!isSuccess) {
                _context16.next = 9;
                break;
              }
              _context16.next = 9;
              return dispatch(reloadCurrentProject());
            case 9:
              return _context16.abrupt("return", isSuccess);
            case 10:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16);
    }));
    return function (_x30, _x31) {
      return _ref17.apply(this, arguments);
    };
  }();
};
exports.updateSurvey = updateSurvey;
var updateSurveySettings = function updateSurveySettings(surveyId, settings) {
  return /*#__PURE__*/function () {
    var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17(dispatch, getState) {
      var response, isSuccess;
      return _regeneratorRuntime().wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return _cccisdAxios["default"].put(Boilerplate.route("api.assignmentSurvey.update", {
                surveyId: surveyId
              }), {
                settings: settings
              });
            case 2:
              response = _context17.sent;
              if (!response.data.errors) {
                _context17.next = 5;
                break;
              }
              throw response.data.errors;
            case 5:
              isSuccess = response.data.status === 'success';
              if (!isSuccess) {
                _context17.next = 9;
                break;
              }
              _context17.next = 9;
              return dispatch(reloadCurrentProject());
            case 9:
              return _context17.abrupt("return", isSuccess);
            case 10:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17);
    }));
    return function (_x32, _x33) {
      return _ref18.apply(this, arguments);
    };
  }();
};
exports.updateSurveySettings = updateSurveySettings;
var archiveSurvey = function archiveSurvey(surveyId) {
  return /*#__PURE__*/function () {
    var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18(dispatch, getState) {
      var response, isSuccess;
      return _regeneratorRuntime().wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return _cccisdAxios["default"].put(Boilerplate.route('api.assignmentSurvey.archive', {
                surveyId: surveyId
              }));
            case 2:
              response = _context18.sent;
              if (response.data.errors && response.data.errors.survey) {
                (0, _cccisdNotification["default"])({
                  type: 'danger',
                  message: response.data.errors.survey[0]
                });
              }
              isSuccess = response.data.status === 'success';
              if (!isSuccess) {
                _context18.next = 8;
                break;
              }
              _context18.next = 8;
              return dispatch(reloadCurrentProject());
            case 8:
              return _context18.abrupt("return", isSuccess);
            case 9:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18);
    }));
    return function (_x34, _x35) {
      return _ref19.apply(this, arguments);
    };
  }();
};
exports.archiveSurvey = archiveSurvey;
var unarchiveSurvey = function unarchiveSurvey(surveyId) {
  return /*#__PURE__*/function () {
    var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19(dispatch, getState) {
      var response, isSuccess;
      return _regeneratorRuntime().wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return _cccisdAxios["default"].put(Boilerplate.route("api.assignmentSurvey.unarchive", {
                surveyId: surveyId
              }));
            case 2:
              response = _context19.sent;
              if (response.data.errors && response.data.errors.survey) {
                (0, _cccisdNotification["default"])({
                  type: 'danger',
                  message: response.data.errors.survey[0]
                });
              }
              isSuccess = response.data.status === 'success';
              if (!isSuccess) {
                _context19.next = 8;
                break;
              }
              _context19.next = 8;
              return dispatch(reloadCurrentProject());
            case 8:
              return _context19.abrupt("return", isSuccess);
            case 9:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19);
    }));
    return function (_x36, _x37) {
      return _ref20.apply(this, arguments);
    };
  }();
};
exports.unarchiveSurvey = unarchiveSurvey;
var deleteSurvey = function deleteSurvey(surveyId) {
  return /*#__PURE__*/function () {
    var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20(dispatch, getState) {
      var response, isSuccess;
      return _regeneratorRuntime().wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return _cccisdAxios["default"].put(Boilerplate.route("api.assignmentSurvey.destroy", {
                surveyId: surveyId
              }));
            case 2:
              response = _context20.sent;
              if (response.data.errors && response.data.errors.survey) {
                (0, _cccisdNotification["default"])({
                  type: 'danger',
                  message: response.data.errors.survey[0]
                });
              }
              isSuccess = response.data.status === 'success';
              if (!isSuccess) {
                _context20.next = 8;
                break;
              }
              _context20.next = 8;
              return dispatch(reloadCurrentProject());
            case 8:
              return _context20.abrupt("return", isSuccess);
            case 9:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20);
    }));
    return function (_x38, _x39) {
      return _ref21.apply(this, arguments);
    };
  }();
};
exports.deleteSurvey = deleteSurvey;
var moveSurveyAndSave = function moveSurveyAndSave(_ref22) {
  var assignmentId = _ref22.assignmentId,
    sourceIndex = _ref22.sourceIndex,
    destinationIndex = _ref22.destinationIndex;
  return /*#__PURE__*/function () {
    var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21(dispatch, getState) {
      var getSurveylistList, prevPositions, updatedSurveys, _iterator, _step, survey;
      return _regeneratorRuntime().wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              getSurveylistList = function getSurveylistList() {
                return (0, _admin.getCurrentProject)(getState().assignment.admin).flows.assignmentList.find(function (item) {
                  return item.assignmentId === assignmentId;
                }).currentSurveylistList.surveyList;
              };
              prevPositions = getSurveylistList().reduce(function (res, item) {
                return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, item.surveyId, item.position));
              }, {});
              dispatch(moveSurvey({
                assignmentId: assignmentId,
                sourceIndex: sourceIndex,
                destinationIndex: destinationIndex
              }));
              updatedSurveys = getSurveylistList().filter(function (item) {
                return prevPositions[item.surveyId] !== item.position;
              }); // TODO: send one request instead of many. For now, do one-at-a-time to
              // ensure we don't 500 with deadlocks
              _iterator = _createForOfIteratorHelper(updatedSurveys);
              _context21.prev = 5;
              _iterator.s();
            case 7:
              if ((_step = _iterator.n()).done) {
                _context21.next = 13;
                break;
              }
              survey = _step.value;
              _context21.next = 11;
              return _cccisdAxios["default"].put(Boilerplate.route("api.assignmentSurvey.update", {
                surveyId: survey.surveyId
              }), {
                ordinalPosition: survey.position
              });
            case 11:
              _context21.next = 7;
              break;
            case 13:
              _context21.next = 18;
              break;
            case 15:
              _context21.prev = 15;
              _context21.t0 = _context21["catch"](5);
              _iterator.e(_context21.t0);
            case 18:
              _context21.prev = 18;
              _iterator.f();
              return _context21.finish(18);
            case 21:
              return _context21.abrupt("return", true);
            case 22:
            case "end":
              return _context21.stop();
          }
        }
      }, _callee21, null, [[5, 15, 18, 21]]);
    }));
    return function (_x40, _x41) {
      return _ref23.apply(this, arguments);
    };
  }();
};
exports.moveSurveyAndSave = moveSurveyAndSave;
var deleteMessage = function deleteMessage(deploymentId, deploymentMessageId) {
  return /*#__PURE__*/function () {
    var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22(dispatch, getState) {
      var response, isSuccess;
      return _regeneratorRuntime().wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              _context22.next = 2;
              return _cccisdAxios["default"].put(Boilerplate.route("api.assignmentDeploymentMessage.destroy", {
                deploymentId: deploymentId,
                deploymentMessageId: deploymentMessageId
              }));
            case 2:
              response = _context22.sent;
              isSuccess = response.data.status === 'success';
              if (!isSuccess) {
                _context22.next = 7;
                break;
              }
              _context22.next = 7;
              return dispatch(reloadCurrentProject());
            case 7:
              return _context22.abrupt("return", isSuccess);
            case 8:
            case "end":
              return _context22.stop();
          }
        }
      }, _callee22);
    }));
    return function (_x42, _x43) {
      return _ref24.apply(this, arguments);
    };
  }();
};
exports.deleteMessage = deleteMessage;
var unscheduleMessage = function unscheduleMessage(deploymentId, deploymentMessageId) {
  return /*#__PURE__*/function () {
    var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee23(dispatch, getState) {
      var response, isSuccess;
      return _regeneratorRuntime().wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              _context23.next = 2;
              return _cccisdAxios["default"].put(Boilerplate.route("api.assignmentDeploymentMessage.destroy", {
                deploymentId: deploymentId,
                deploymentMessageId: deploymentMessageId
              }));
            case 2:
              response = _context23.sent;
              isSuccess = response.data.status === 'success';
              if (!isSuccess) {
                _context23.next = 7;
                break;
              }
              _context23.next = 7;
              return dispatch(reloadCurrentProject());
            case 7:
              return _context23.abrupt("return", isSuccess);
            case 8:
            case "end":
              return _context23.stop();
          }
        }
      }, _callee23);
    }));
    return function (_x44, _x45) {
      return _ref25.apply(this, arguments);
    };
  }();
};
exports.unscheduleMessage = unscheduleMessage;
var createFlow = function createFlow(data) {
  return /*#__PURE__*/function () {
    var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee24(dispatch, getState) {
      var response, result, isSuccess;
      return _regeneratorRuntime().wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              _context24.next = 2;
              return _cccisdAxios["default"].post(Boilerplate.route('flow.store'), data);
            case 2:
              response = _context24.sent;
              // Repsonse format is Task Master if it's copying from template or existing survey
              result = response.data.result || response.data;
              if (!result.errors) {
                _context24.next = 6;
                break;
              }
              throw result.errors;
            case 6:
              isSuccess = result.status === 'success';
              if (!isSuccess) {
                _context24.next = 10;
                break;
              }
              _context24.next = 10;
              return dispatch(reloadCurrentProject());
            case 10:
              return _context24.abrupt("return", isSuccess);
            case 11:
            case "end":
              return _context24.stop();
          }
        }
      }, _callee24);
    }));
    return function (_x46, _x47) {
      return _ref26.apply(this, arguments);
    };
  }();
};
exports.createFlow = createFlow;
var createWave = function createWave(assignmentId, values) {
  return /*#__PURE__*/function () {
    var _ref27 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee25(dispatch, getState) {
      var response, isSuccess;
      return _regeneratorRuntime().wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              _context25.next = 2;
              return _cccisdAxios["default"].post(Boilerplate.route('api.assignmentDeployment.store'), _objectSpread(_objectSpread({}, values), {}, {
                assignmentId: assignmentId
              }));
            case 2:
              response = _context25.sent;
              if (!response.data.errors) {
                _context25.next = 5;
                break;
              }
              throw response.data.errors;
            case 5:
              isSuccess = response.data.status === 'success';
              if (!isSuccess) {
                _context25.next = 11;
                break;
              }
              _context25.next = 9;
              return dispatch(reloadCurrentProject());
            case 9:
              _context25.next = 11;
              return dispatch(setCurrentDeploymentId(response.data.data.id));
            case 11:
              return _context25.abrupt("return", isSuccess);
            case 12:
            case "end":
              return _context25.stop();
          }
        }
      }, _callee25);
    }));
    return function (_x48, _x49) {
      return _ref27.apply(this, arguments);
    };
  }();
};
exports.createWave = createWave;
var updateWave = function updateWave(deploymentId, values) {
  return /*#__PURE__*/function () {
    var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee26(dispatch, getState) {
      var response, isSuccess;
      return _regeneratorRuntime().wrap(function _callee26$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              _context26.next = 2;
              return _cccisdAxios["default"].put(Boilerplate.route('api.assignmentDeployment.update', {
                deploymentId: deploymentId
              }), values);
            case 2:
              response = _context26.sent;
              isSuccess = response.data.status === 'success';
              if (!isSuccess) {
                _context26.next = 9;
                break;
              }
              _context26.next = 7;
              return dispatch(reloadCurrentProject());
            case 7:
              _context26.next = 9;
              return dispatch(setCurrentDeploymentId(deploymentId));
            case 9:
              return _context26.abrupt("return", response);
            case 10:
            case "end":
              return _context26.stop();
          }
        }
      }, _callee26);
    }));
    return function (_x50, _x51) {
      return _ref28.apply(this, arguments);
    };
  }();
};
exports.updateWave = updateWave;
var removeWave = function removeWave(deploymentId) {
  return /*#__PURE__*/function () {
    var _ref29 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee27(dispatch, getState) {
      var response;
      return _regeneratorRuntime().wrap(function _callee27$(_context27) {
        while (1) {
          switch (_context27.prev = _context27.next) {
            case 0:
              _context27.next = 2;
              return _cccisdAxios["default"].put(Boilerplate.route('api.assignmentDeployment.destroy', {
                deploymentId: deploymentId
              }));
            case 2:
              response = _context27.sent;
              if (!(response.data.status !== 'success')) {
                _context27.next = 5;
                break;
              }
              return _context27.abrupt("return", response);
            case 5:
              _context27.next = 7;
              return dispatch(reloadCurrentProject());
            case 7:
            case "end":
              return _context27.stop();
          }
        }
      }, _callee27);
    }));
    return function (_x52, _x53) {
      return _ref29.apply(this, arguments);
    };
  }();
};
exports.removeWave = removeWave;
var setWaveOpenStatusAndSave = function setWaveOpenStatusAndSave(_ref30) {
  var deploymentId = _ref30.deploymentId,
    isOpen = _ref30.isOpen;
  return /*#__PURE__*/function () {
    var _ref31 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee28(dispatch, getState) {
      return _regeneratorRuntime().wrap(function _callee28$(_context28) {
        while (1) {
          switch (_context28.prev = _context28.next) {
            case 0:
              dispatch(setWaveOpenStatus({
                deploymentId: deploymentId,
                isOpen: isOpen
              }));
              _context28.next = 3;
              return _cccisdAxios["default"].put(Boilerplate.route('api.assignmentDeployment.update', {
                deploymentId: deploymentId
              }), {
                isOpen: isOpen
              });
            case 3:
            case "end":
              return _context28.stop();
          }
        }
      }, _callee28);
    }));
    return function (_x54, _x55) {
      return _ref31.apply(this, arguments);
    };
  }();
};

// reducer
exports.setWaveOpenStatusAndSave = setWaveOpenStatusAndSave;
var _default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, SET_ORGANIZATION_LIST, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    organizationList: action.payload
  });
}), _defineProperty(_handleActions, SET_PROJECT_LIST, function (state, action) {
  var projectList = action.payload;
  var queryList = [];
  var _iterator2 = _createForOfIteratorHelper(projectList),
    _step2;
  try {
    var _loop = function _loop() {
      var _project$settings;
      var project = _step2.value;
      var projectQueries = ((_project$settings = project.settings) === null || _project$settings === void 0 ? void 0 : _project$settings.queryList) || [];
      queryList.push.apply(queryList, _toConsumableArray(projectQueries.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          projectId: project.groupId
        });
      })));
    };
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    projectList: projectList,
    queryList: queryList
  });
}), _defineProperty(_handleActions, SET_CURRENT_PROJECT_ID, function (state, action) {
  var nextState = _objectSpread(_objectSpread({}, state), {}, {
    currentQueryId: '0',
    currentProjectId: action.payload,
    currentQuerySettings: _objectSpread({}, defaultQuerySettings)
  });
  var currentAssignmentId = state.currentAssignmentId,
    currDepId = state.currentDeploymentId,
    visibleDeploymentIds = state.visibleDeploymentIds;
  var activeAssignmentsIds = (0, _admin.getCurrentProjectActiveAssignments)(nextState).filter(function (item) {
    return !visibleDeploymentIds || item.deploymentList.length > 0;
  }).map(function (item) {
    return item.assignmentId;
  });
  nextState.currentQuerySettings.assignmentId = currentAssignmentId;
  nextState.currentQuerySettings.deploymentIds = 'all';
  nextState.currentQuerySettings.surveyHandles = 'all';
  if (!activeAssignmentsIds.includes(currentAssignmentId)) {
    nextState.currentAssignmentId = activeAssignmentsIds[0] || 0;
    nextState.currentQuerySettings.assignmentId = activeAssignmentsIds[0] || 0;
  }
  var assignmentDeployments = (0, _admin.getCurrentAssignmentDeployments)(nextState).filter(function (item) {
    return !item.archived;
  });
  var assignmentDeploymentsIds = assignmentDeployments.map(function (item) {
    return item.deploymentId;
  });
  var currentDeploymentId = !assignmentDeploymentsIds.some(function (id) {
    return id === currDepId;
  }) ? assignmentDeploymentsIds[0] || 0 : currDepId;
  nextState.currentDeploymentId = currentDeploymentId;
  nextState.currentDeploymentIds = currentDeploymentId ? [currentDeploymentId] : [];
  nextState.selectedDeploymentIds = currentDeploymentId ? [currentDeploymentId] : [];
  nextState.currentSurveyHandles = [];

  // get default columns
  {
    (function () {
      var deploymentList = (0, _admin.getCurrentQueryAssignmentActiveDeployments)(nextState);
      var roleHandles = (0, _uniq2["default"])(deploymentList.map(function (item) {
        return item.roleHandle;
      }));
      var columns = {};
      var _iterator3 = _createForOfIteratorHelper(roleHandles),
        _step3;
      try {
        var _loop2 = function _loop2() {
          var roleHandle = _step3.value;
          var levelInfo = window.cccisd.appDefs.pawn.roles.find(function (item) {
            return item.handle === roleHandle;
          });
          if (!levelInfo) {
            return "continue";
          }
          var columnTree = (0, _getColumnTree.getFlatColumnTree)('roles', levelInfo.handle);
          var importantFields = Array.isArray(levelInfo.importantFields) ? levelInfo.importantFields : [];
          importantFields.filter(function (field) {
            return field.path in columnTree;
          }).forEach(function (field) {
            columns[field.path] = columnTree[field.path];
          });
        };
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _ret = _loop2();
          if (_ret === "continue") continue;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      nextState.currentQuerySettings.columns = columns;
    })();
  }
  return nextState;
}), _defineProperty(_handleActions, SET_CURRENT_ASSIGNMENT_ID, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    currentAssignmentId: parseInt(action.payload, 10),
    currentDeploymentId: initialState.currentDeploymentId,
    currentDeploymentIds: [],
    selectedDeploymentIds: [],
    currentSurveyHandles: []
  });
}), _defineProperty(_handleActions, SET_CURRENT_ASSIGNMENT_ID_ONLY, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    currentAssignmentId: parseInt(action.payload, 10)
  });
}), _defineProperty(_handleActions, SET_CURRENT_DEPLOYMENT_ID, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    currentDeploymentId: parseInt(action.payload, 10),
    currentDeploymentIds: action.payload !== 0 ? [parseInt(action.payload, 10)] : [],
    selectedDeploymentIds: action.payload !== 0 ? [parseInt(action.payload, 10)] : []
  });
}), _defineProperty(_handleActions, SET_SELECTED_DEPLOYMENT_IDS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    selectedDeploymentIds: action.payload
  });
}), _defineProperty(_handleActions, SET_CURRENT_DEPLOYMENT_IDS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    currentDeploymentId: action.payload.length ? parseInt(action.payload[0], 10) : initialState.currentDeploymentId,
    currentDeploymentIds: action.payload
  });
}), _defineProperty(_handleActions, SET_CURRENT_SURVEY_ID, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    currentSurveyId: parseInt(action.payload, 10)
  });
}), _defineProperty(_handleActions, SET_CURRENT_SURVEY_HANDLE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    currentSurveyHandle: action.payload
  });
}), _defineProperty(_handleActions, SET_CURRENT_SURVEY_HANDLES, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    currentSurveyHandles: action.payload
  });
}), _defineProperty(_handleActions, SET_PROJECT_FLOWS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    projectList: state.projectList.map(function (project) {
      return project.groupId === action.payload.groupId ? _objectSpread(_objectSpread({}, project), {}, {
        flows: action.payload.flows
      }) : project;
    })
  });
}), _defineProperty(_handleActions, SET_EXPANDED_ALL_DESIGN_ASSIGNMENTS, function (state, action) {
  var expand = action.payload;
  var currentProjectAssignmentIds = (0, _admin.getCurrentProjectAssignments)(state).map(function (obj) {
    return obj.assignmentId;
  });
  var expandedDesignAssignmentIds = expand ? (0, _union2["default"])(state.expandedDesignAssignmentIds, currentProjectAssignmentIds) : (0, _difference2["default"])(state.expandedDesignAssignmentIds, currentProjectAssignmentIds);
  return _objectSpread(_objectSpread({}, state), {}, {
    expandedDesignAssignmentIds: expandedDesignAssignmentIds
  });
}), _defineProperty(_handleActions, TOGGLE_COLLAPSED_DESIGN_ASSIGNMENT, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    expandedDesignAssignmentIds: (0, _xor2["default"])(state.expandedDesignAssignmentIds, [action.payload])
  });
}), _defineProperty(_handleActions, SET_EXPANDED_ALL_DEPLOY_ASSIGNMENTS, function (state, action) {
  var expand = action.payload;
  var currentProjectAssignmentIds = (0, _admin.getCurrentProjectAssignments)(state).map(function (obj) {
    return obj.assignmentId;
  });
  var expandedDeployAssignmentIds = expand ? (0, _union2["default"])(state.expandedDeployAssignmentIds, currentProjectAssignmentIds) : (0, _difference2["default"])(state.expandedDeployAssignmentIds, currentProjectAssignmentIds);
  return _objectSpread(_objectSpread({}, state), {}, {
    expandedDeployAssignmentIds: expandedDeployAssignmentIds
  });
}), _defineProperty(_handleActions, TOGGLE_COLLAPSED_DEPLOY_ASSIGNMENT, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    expandedDeployAssignmentIds: (0, _xor2["default"])(state.expandedDeployAssignmentIds, [action.payload])
  });
}), _defineProperty(_handleActions, TOGGLE_ARCHIVED_ASSIGNMENTS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    showArchivedAssignments: !state.showArchivedAssignments
  });
}), _defineProperty(_handleActions, TOGGLE_ARCHIVED_SURVEYS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    showArchivedSurveys: (0, _xor2["default"])(state.showArchivedSurveys, [action.payload])
  });
}), _defineProperty(_handleActions, SET_CURRENT_SURVEY_LIST_HANDLE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    currentSurveyListHandles: _objectSpread(_objectSpread({}, state.currentSurveyListHandles), {}, _defineProperty({}, action.payload.assignmentId, action.payload.handle))
  });
}), _defineProperty(_handleActions, MOVE_SURVEY, function (state, action) {
  var _action$payload = action.payload,
    assignmentId = _action$payload.assignmentId,
    sourceIndex = _action$payload.sourceIndex,
    destinationIndex = _action$payload.destinationIndex;
  var currentProjectId = state.currentProjectId,
    currentSurveyListHandles = state.currentSurveyListHandles;
  try {
    var sortByPosition = function sortByPosition(a, b) {
      return a.position - b.position;
    };
    var projectList = (0, _cloneDeep2["default"])(state.projectList);
    var currentProject = projectList.find(function (item) {
      return item.groupId === currentProjectId;
    });
    var currentAssignment = currentProject.flows.assignmentList.find(function (item) {
      return item.assignmentId === assignmentId;
    });
    var currentSurveylistList = currentSurveyListHandles[assignmentId] ? currentAssignment.surveylistList.find(function (item) {
      return item.surveylistHandle === currentSurveyListHandles[assignmentId];
    }) : currentAssignment.surveylistList[0];
    var surveyList = currentSurveylistList.surveyList.sort(sortByPosition);
    var activeSurveyList = surveyList.filter(function (item) {
      return !item.archived;
    });
    var sourcePosition = activeSurveyList[sourceIndex].position;
    var destinationPosition = activeSurveyList[destinationIndex].position;
    currentSurveylistList.surveyList = surveyList.map(function (item) {
      var position = item.position;
      if (item.position === sourcePosition) {
        position = destinationPosition;
      } else if (item.position > sourcePosition && item.position <= destinationPosition) {
        position = item.position - 1;
      } else if (item.position < sourcePosition && item.position >= destinationPosition) {
        position = item.position + 1;
      }
      return _objectSpread(_objectSpread({}, item), {}, {
        position: position
      });
    }).sort(sortByPosition);
    return _objectSpread(_objectSpread({}, state), {}, {
      projectList: projectList
    });
  } catch (e) {
    return state;
  }
}), _defineProperty(_handleActions, SET_WAVE_OPEN_STATUS, function (state, action) {
  var _action$payload2 = action.payload,
    deploymentId = _action$payload2.deploymentId,
    isOpen = _action$payload2.isOpen;
  var currentProjectId = state.currentProjectId;
  try {
    var projectList = (0, _cloneDeep2["default"])(state.projectList);
    var currentProject = projectList.find(function (item) {
      return item.groupId === currentProjectId;
    });
    var deployments = currentProject.flows.assignmentList.reduce(function (res, assignment) {
      return [].concat(_toConsumableArray(res), _toConsumableArray(assignment.deploymentList));
    }, []);
    var currentDeployment = deployments.find(function (item) {
      return item.deploymentId === deploymentId;
    });
    currentDeployment.isOpen = isOpen;
    return _objectSpread(_objectSpread({}, state), {}, {
      projectList: projectList
    });
  } catch (e) {
    return state;
  }
}), _defineProperty(_handleActions, CHANGE_DESIGN_FILTER, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    designFilter: action.payload
  });
}), _defineProperty(_handleActions, CHANGE_DEPLOY_FILTER, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    deployFilter: action.payload
  });
}), _defineProperty(_handleActions, SET_DEV_TAGS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    devTags: action.payload
  });
}), _defineProperty(_handleActions, SET_QUERY_LIST, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    queryList: action.payload
  });
}), _defineProperty(_handleActions, ADD_NEW_QUERY, function (state, action) {
  var newId = (0, _nanoid.nanoid)();
  var projectId = state.currentProjectId;
  if (!projectId) {
    return state;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    currentQuerySettings: _objectSpread(_objectSpread({}, state.currentQuerySettings), {}, {
      visualizationSettings: action.payload.settings.visualizationSettings
    }),
    queryList: [].concat(_toConsumableArray(state.queryList), [_objectSpread(_objectSpread({}, action.payload), {}, {
      id: newId,
      projectId: projectId
    })]),
    currentQueryId: newId
  });
}), _defineProperty(_handleActions, UPDATE_QUERY, function (state, action) {
  var _action$payload3, _action$payload3$sett;
  var newState = _objectSpread(_objectSpread({}, state), {}, {
    queryList: state.queryList.map(function (query) {
      if (query.id !== action.payload.id) {
        return query;
      }
      return _objectSpread(_objectSpread({}, query), action.payload);
    })
  });
  if (state.currentQuerySettings && (_action$payload3 = action.payload) !== null && _action$payload3 !== void 0 && (_action$payload3$sett = _action$payload3.settings) !== null && _action$payload3$sett !== void 0 && _action$payload3$sett.visualizationSettings) {
    newState.currentQuerySettings = _objectSpread(_objectSpread({}, state.currentQuerySettings), {}, {
      visualizationSettings: action.payload.settings.visualizationSettings
    });
  }
  return newState;
}), _defineProperty(_handleActions, DELETE_CURRENT_QUERY, function (state, action) {
  if (!state.currentQueryId || state.currentQueryId === '0') {
    return state;
  }
  var queryList = state.queryList.filter(function (query) {
    return query.id !== state.currentQueryId;
  });
  var currentQueryId = queryList.length > 0 ? queryList[0].id : '0';
  var currentQuerySettings = queryList.length > 0 ? queryList[0].settings : state.currentQuerySettings;
  return _objectSpread(_objectSpread({}, state), {}, {
    queryList: queryList,
    currentQueryId: currentQueryId,
    currentQuerySettings: currentQuerySettings
  });
}), _defineProperty(_handleActions, SET_CURRENT_QUERY_ID, function (state, action) {
  var nextQueryId = action.payload;
  if (nextQueryId === state.currentQueryId) {
    return state;
  }
  var nextState = _objectSpread(_objectSpread({}, state), {}, {
    currentQueryId: nextQueryId
  });
  if (nextQueryId !== '0') {
    var foundQuery = state.queryList.find(function (query) {
      return query.id === nextQueryId;
    });
    if (!foundQuery) {
      // something wrong
      return state;
    }
    nextState.currentQuerySettings = foundQuery.settings;
  } else {
    var visibleDeploymentIds = state.visibleDeploymentIds;

    // revert everything to default
    nextState.currentQuerySettings = _objectSpread({}, defaultQuerySettings);
    var activeAssignmentsIds = (0, _admin.getCurrentProjectActiveAssignments)(nextState).filter(function (item) {
      return !visibleDeploymentIds || item.deploymentList.length > 0;
    }).map(function (item) {
      return item.assignmentId;
    });
    if (activeAssignmentsIds.length === 0) {
      return nextState;
    }
    nextState.currentQuerySettings.assignmentId = activeAssignmentsIds[0];

    // get default columns
    {
      (function () {
        var deploymentList = (0, _admin.getCurrentQueryAssignmentActiveDeployments)(nextState);
        var roleHandles = (0, _uniq2["default"])(deploymentList.map(function (item) {
          return item.roleHandle;
        }));
        var columns = {};
        var _iterator4 = _createForOfIteratorHelper(roleHandles),
          _step4;
        try {
          var _loop3 = function _loop3() {
            var roleHandle = _step4.value;
            var levelInfo = window.cccisd.appDefs.pawn.roles.find(function (item) {
              return item.handle === roleHandle;
            });
            if (!levelInfo) {
              return "continue";
            }
            var columnTree = (0, _getColumnTree.getFlatColumnTree)('roles', levelInfo.handle);
            var importantFields = Array.isArray(levelInfo.importantFields) ? levelInfo.importantFields : [];
            importantFields.filter(function (field) {
              return field.path in columnTree;
            }).forEach(function (field) {
              columns[field.path] = columnTree[field.path];
            });
          };
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _ret2 = _loop3();
            if (_ret2 === "continue") continue;
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        nextState.currentQuerySettings.columns = columns;
      })();
    }
  }
  return nextState;
}), _defineProperty(_handleActions, SET_CURRENT_QUERY_SETTINGS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    currentQuerySettings: action.payload || defaultQuerySettings
  });
}), _defineProperty(_handleActions, SET_VIZ_DATA, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    vizData: _objectSpread(_objectSpread({}, state.vizData), action.payload)
  });
}), _defineProperty(_handleActions, SET_VISIBLE_DEPLOYMENT_IDS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    visibleDeploymentIds: action.payload
  });
}), _defineProperty(_handleActions, CLEAR_VISIBLE_DEPLOYMENT_IDS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    visibleDeploymentIds: null
  });
}), _defineProperty(_handleActions, RESET_STATE, function (state, action) {
  return initialState;
}), _handleActions), initialState);
exports["default"] = _default;